import ApiService from "./ApiService"

const get = (url) => {
    return  ApiService.get('/api/suscripciones' + url);
}


export default {
    get
}


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/services/apiSuscripciones.js